/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Contact_TypeInputs */

const en_clients_field_contact_type = /** @type {(inputs: Clients_Field_Contact_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact type`)
};

const pt_br2_clients_field_contact_type = /** @type {(inputs: Clients_Field_Contact_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de contato`)
};

/**
* | output |
* | --- |
* | "Contact type" |
*
* @param {Clients_Field_Contact_TypeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_contact_type = /** @type {((inputs?: Clients_Field_Contact_TypeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Contact_TypeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_contact_type(inputs)
	return pt_br2_clients_field_contact_type(inputs)
});